<template>
    <div>
        <div class="topleft">
            <div class="logo" :style="logowid">
                <img :src="logourl" alt="" style="margin-top:-9px;">
            </div>
            <span class="closemenu" @click="changeMenu">
                <i :class="icon"></i>
            </span>
            <span class="closemenu" @click="gotohome" style="border-left:none;">
                <i class="el-icon-s-home"></i>
            </span>
            <span class="closemenu" v-if="userInfo.user.roles[0].id == 1" @click="analyse" 
                style="border-left:none;">
                <i class="el-icon-share"></i>
            </span>
        </div>
        <div class="topright">
            <em>
                {{userInfo.user.nickName}}（{{userInfo.user.roles[0].name}}）

                ｜语言：
                <span class="lang-btn" @click="changeType('zh')">中文</span>
                <span class="lang-btn" @click="changeType('en')">English</span>
                <span class="lang-btn" @click="changeType('es')">Español</span>

                ｜时间：
                <span style="color: red;">{{currentTime}}</span>
            </em>
            <el-dropdown style="vertical-align: middle;">
                <span class="el-dropdown-link">
                    <el-avatar size="medium" src="/img/header.jpg"></el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="gotochange"><span>修改密码</span></el-dropdown-item>
                    <el-dropdown-item @click.native="logOut"><span >退出登录</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/public"
import _api from "@/api/index"


import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)


export default {
    data(){
        return{
            isclose:false,
            icon:"el-icon-s-fold",
            userInfo:{},
            logowid:"width: 200px;",
            nt:"墨西哥",
            currentTime:null,
            timer:null,

            timezoneMap:{
                mx:"America/Mexico_City",
                pe:"America/Lima"
            }
        }
    },
    props:{
        logourl:{
            type:String
        },
    },
    created(){
        let userInfo2 = JSON.parse(window.localStorage.getItem('userinfo'))
        this.userInfo = userInfo2

        var nation = localStorage.getItem("nation")
        if (userInfo2.user.roles[0].id != 1) {
            sessionStorage.setItem("nation", userInfo2.user.nation);
            localStorage.setItem("nation", userInfo2.user.nation);
            if (userInfo2.user.nation == "pe") {
                this.nt = "秘鲁"
            }
        } else {
            if (nation == null) {
                sessionStorage.setItem("nation", "mx");
                localStorage.setItem("nation", "mx");
                this.nt = "墨西哥"
            }
            if (nation != null && nation == "pe") {
                this.nt = "秘鲁"
            }
        }

        this.setNation(nation)

        this.updateTime()
        this.timer = setInterval(this.updateTime, 1000)


        var lang = localStorage.getItem("lang")
        if (lang == null) {
            this.changeType("es_US");
        }
        setTimeout(() => {
            this.getHint()
        }, 1000);

        setInterval(() => {
            this.fn()
        }, 1000); 
    },

    beforeDestroy(){
        clearInterval(this.timer)
    },

    state:{
        menuRefreshFlag: 0
    },

    mutations:{
        triggerMenuRefresh(state){
            state.menuRefreshFlag++
        }
    },

    methods:{
        changeType(type) {
            this.$nextTick(() => {
                sessionStorage.setItem("locale", type);
                this.$i18n.locale = type;
                localStorage.setItem("lang", this.$t("lang"));
            });

            // 获取菜单列表
            _api.get(apiurl.usermenu, {
                lang:this.$t("lang")
            }).then(ress => {
                localStorage.setItem("menu", JSON.stringify(ress))
                localStorage.setItem("num", 0)

                this.$store.commit("triggerMenuRefresh")
            })
            //this.login();
        },
        changeNation(type){
            this.$nextTick(() => {
                sessionStorage.setItem("nation", type);
                localStorage.setItem("nation", type);
            });
            this.login();
        },
        setNation(type){
            this.nt = type === "pe" ? "秘鲁" : "墨西哥"
            this.currentTimezone = this.timezoneMap[type] || "UTC"
        },
        updateTime(){
            this.currentTime = dayjs().tz(this.currentTimezone).format("YYYY-MM-DD HH:mm:ss")
        },
        login(){
            this.$alert(this.$t('login1'), this.$t('login2'), {
                confirmButtonText: this.$t('login3'),
                callback: action => {
                    this.$message({
                        type: 'info',
                        message: `action: ${ action }`
                    });
                    this.logOut()
                }
            });
        },
        gotochange(){
            this.$router.push("/changepass")
        },
        gotohome(){
            if (this.userInfo.user.roles[0].id == 1) {
                this.$router.push("/home")
            } else if (this.userInfo.user.roles[0].id == 3) {
                this.$router.push({path:"/mycall"})
            } else if (this.userInfo.user.roles[0].id == 5) {
                this.$router.push({path:"/usercheck"})
            } else if (this.userInfo.user.roles[0].id == 9) {
                this.$router.push({path:"/loan"})
            } else if (this.userInfo.user.roles[0].id == 14) {
                this.$router.push({path:"/mycallnew"})
            } else{
                this.$router.push({path:"/mycall"})
            }
        },
        analyse() {
            window.open('http://hx.easylend.live/#/Tools');
        },
        changeMenu(){
            if(!this.isclose){
                this.$emit("getchange",true)
                this.icon="el-icon-s-unfold"
                this.isclose=true
                this.logowid="width: 68px;"
            }else{
                this.$emit("getchange",false)
                this.icon="el-icon-s-fold"
                this.isclose=false
                this.logowid="width: 200px;"
            }
        },
        userCenter(){},
        logOut(){
            _api.delete(apiurl.logout,{}).then(res=>{
                this.$notify.success({
                    title: this.$t('success'),
                    message: this.$t('login4')
                });
                this.$store.commit("cleartag","")
                localStorage.removeItem("menu")
                localStorage.removeItem("num")
                localStorage.removeItem("userinfo")
                localStorage.removeItem("token")
                this.$router.push("/login")
            }).catch(err=>{
                localStorage.clear()
                this.$router.push("/login")
            })
        },
        getHint(){
            _api.get(apiurl.getUserTime,{
                nation: localStorage.getItem("nation"),
            }).then(res => {
                    this.$alert('app已经有：' + res.data + '分钟没有新增用户了', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'info',
                            message: `action: ${ action }`
                        });
                    }
                });
            })
        },

        fn(){
            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            if (this.nt == "墨西哥") {
                this.timeArr = UTCTime - 6 * 60 * 60 * 1000;
            } else {
                this.timeArr = UTCTime - 5 * 60 * 60 * 1000;
            }
        } 
    }
}
</script>
<style scoped>
.topleft{ float: left; padding-top: 0px;}
.closemenu{ display: inline-block; padding-top: 4px; width: 50px; height:50px; cursor: pointer; text-align: center; line-height: 50px; border-left: rgba(255,255,255,0.1) solid 1px;border-right: rgba(255,255,255,0.1) solid 1px;}
.closemenu i{ font-size: 20px; color: #ffffff;}
.topright{ float: right; padding-top: 7px;}
.topright em{font-size: 14px; font-style: normal; vertical-align: middle; margin-right:15px; color: #ffffff;}
.logo{display: inline-block; text-align:center; cursor: pointer; height: 50px; position: relative; z-index: 3000; color: #ffffff; line-height: 50px; font-size: 18px;}
.lang-btn {
    margin: 0 5px;
    cursor: pointer;
    color: #409EFF;
}
.lang-btn:hover {
    text-decoration: underline;
}
</style>